__turbopack_context__.v({
  "chartContainer": "style-module-scss-module__1wfekW__chartContainer",
  "component": "style-module-scss-module__1wfekW__component",
  "current-median": "style-module-scss-module__1wfekW__current-median",
  "current-median-percentage": "style-module-scss-module__1wfekW__current-median-percentage",
  "date": "style-module-scss-module__1wfekW__date",
  "hover-circle": "style-module-scss-module__1wfekW__hover-circle",
  "hover-line": "style-module-scss-module__1wfekW__hover-line",
  "last-updated": "style-module-scss-module__1wfekW__last-updated",
  "line-path": "style-module-scss-module__1wfekW__line-path",
  "negative": "style-module-scss-module__1wfekW__negative",
  "no-data": "style-module-scss-module__1wfekW__no-data",
  "no-data-disclaimer": "style-module-scss-module__1wfekW__no-data-disclaimer",
  "one-year-ago": "style-module-scss-module__1wfekW__one-year-ago",
  "one-year-ago-price": "style-module-scss-module__1wfekW__one-year-ago-price",
  "positive": "style-module-scss-module__1wfekW__positive",
  "price": "style-module-scss-module__1wfekW__price",
  "row": "style-module-scss-module__1wfekW__row",
  "stats": "style-module-scss-module__1wfekW__stats",
  "subtitle": "style-module-scss-module__1wfekW__subtitle",
  "title": "style-module-scss-module__1wfekW__title",
  "tooltip-content": "style-module-scss-module__1wfekW__tooltip-content",
  "visible": "style-module-scss-module__1wfekW__visible",
  "x-axis": "style-module-scss-module__1wfekW__x-axis",
  "y-axis": "style-module-scss-module__1wfekW__y-axis",
});
